module.exports = __webpack_public_path__ + "img/google-cloud-platform.6ac5a438.jpg";